<template>
        <import from="../log-window/log-window"></import>
        <log-window></log-window>
</template>
